import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { CidadeDTO } from "./cadastro/saude/CidadeDTO";
import { CidadePageResultDTO } from "./cadastro/saude/CidadePageResultDTO";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudeCidadesApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  obterCidade(filtro: any) {
    return this.get("/cidades", {
      params: filtro,
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  pesquisarCidades(estado: string): Promise<CidadeDTO[]> {
    return this.get<CidadePageResultDTO>("/cidades", {
      params: { estado, size: 1000 },
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .then((data) => {
        const { content } = data;
        return content || [];
      })
      .catch((err) => {
        throw new Error(`Falha ao consultar cidades do estado: ${estado}`);
      });
  }

  salvarCidade(cidade: any): Promise<string> {
    return this.post<EspecialidadeModel>("/cidades", cidade)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarCidade(idCidade: Number, cidade: any): Promise<string> {
    return this.put<any>(`/cidades/${idCidade}`, cidade)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  obterCidadePorId(idCidade: Number): Promise<any> {
    return this.get(`/cidades/${idCidade}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter cidade.");
      });
  }

  obterCidadesPorEstado(uf?: string): Promise<any> {
    return this.get(`/cidades/estado/${uf}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter cidades.");
      });
  }

  deletarCidade(idCidade: Number): Promise<any> {
    return this.delete(`/cidades/${idCidade}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }
}

export const servicosSaudeCidadesApi = new ServicosSaudeCidadesApi(servicosSaudeApiConfig);
